/**
 * Enter here the user flows and custom policies for your B2C application
 */

const b2cPolicies = {
    names: {
        signUpSignIn: process.env.VUE_APP_B2C_SIGNUP_SIGNIN_POLICY_NAME,
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.VUE_APP_B2C_AUTHORITY,
        },
    },
    authorityDomain: process.env.VUE_APP_B2C_AUTHORITY_DOMAIN,
}

export default b2cPolicies;